import type { AnalysisResult, ProcessingSummary } from '../core/types';

function Stat({ label, value, warning = false }: { label: string; value: string | number; warning?: boolean }) {
  return (
    <div className={warning ? 'stat warning' : 'stat'}>
      <span>{label}</span>
      <strong>{value}</strong>
    </div>
  );
}

export function AnalysisSummary({ analysis }: { analysis: AnalysisResult | null }) {
  if (!analysis) return null;
  const s = analysis.preflightSummary;
  return (
    <section className="card">
      <h2>Resumo da análise</h2>
      <div className="stats-grid">
        <Stat label="Arquivos" value={s.filesRead} />
        <Stat label="Lojas" value={s.storesDetected} />
        <Stat label="Funcionários" value={s.employeesDetected} />
        <Stat label="Batidas parseadas" value={s.parsedPunches} />
        <Stat label="Duplicatas removidas" value={s.duplicatesRemoved} warning={s.duplicatesRemoved > 0} />
        <Stat label="Alertas proximidade" value={s.nearDuplicateWarnings} warning={s.nearDuplicateWarnings > 0} />
        <Stat label="Jornadas disponíveis" value={s.shiftsAvailable} />
        <Stat label="Ocorrências parse" value={s.parseIssues} warning={s.parseIssues > 0} />
      </div>
    </section>
  );
}

export function GenerationSummary({ summary }: { summary: ProcessingSummary | null }) {
  if (!summary) return null;
  return (
    <section className="card success-card">
      <h2>Resultado</h2>
      <p>
        Competência <strong>{summary.periodLabel}</strong> — {summary.periodRange}
      </p>
      <div className="stats-grid">
        <Stat label="Batidas parseadas" value={summary.parsedPunches} />
        <Stat label="Duplicatas removidas" value={summary.duplicatesRemoved} warning={summary.duplicatesRemoved > 0} />
        <Stat label="Batidas utilizadas" value={summary.usedPunches} />
        <Stat label="Jornadas formadas" value={summary.shiftsFormed} />
        <Stat label="Jornadas sucesso" value={summary.successShifts} />
        <Stat label="Jornadas revisão" value={summary.reviewShifts} warning={summary.reviewShifts > 0} />
        <Stat label="Alertas proximidade" value={summary.nearDuplicateWarnings} warning={summary.nearDuplicateWarnings > 0} />
        <Stat label="Ocorrências parse" value={summary.parseIssues} warning={summary.parseIssues > 0} />
      </div>
    </section>
  );
}
